const data = {
  dengue: [
    [15.9240905, 80.1863809],
    [22.2793278, 114.16281310000001],
    [16.5160826, 81.7233251],
    [14.55, 77.416667],
    [17.3616079, 78.4746286],
    [12.979119800000001, 77.5912997],
    [15.830925099999998, 78.0425373],
    [17.23143615, 78.4316745265238],
    [17.3616079, 78.4746286],
    [12.979119800000001, 77.5912997],
    [17.3616079, 78.4746286],
    [20.216667, 74.083333],
    [15.9240905, 80.1863809],
    [25.609323899999996, 85.1235252],
    [16.5087586, 80.6185102],
    [16.0522252, 79.74212709999999],
    [23.0216238, 72.5797068],
    [-33.8548157, 151.2164539],
    [16.2915189, 80.4541588],
    [22.3511148, 78.6677428],
    [35.4787888, 72.5850016],
    [30.3308401, 71.247499],
    [22.3511148, 78.6677428],
    [30.3308401, 71.247499],
    [13.080172099999999, 80.2838331]
  ],
  ebola: [
    [-18.1415884, 178.44216619999997],
    [30.3308401, 71.247499],
    [38.7604815, -92.5617875],
    [29.8108436, -95.15012759999999],
    [35.6729639, -79.03929190000001],
    [-33.4377968, -70.65044509999998],
    [34.0536834, -118.24276689999999],
    [63.445531, 10.9032872],
    [2.0000003, 15.9999997],
    [33.8347516, -117.911732],
    [54.702354500000006, -3.2765752999999997],
    [-37.814217600000006, 144.9631608],
    [-1.2832533000000002, 36.8172449],
    [-1.2832533000000002, 36.8172449],
    [-0.71845775, 35.239124806149704],
    [50.7852181, -0.6732775]
  ],
  flu: [
    [31.8160381, -99.51209859999999],
    [32.7174209, -117.16277140000001],
    [33.9597677, -83.376398],
    [9.6000359, 7.999972099999999],
    [44.9184068, 8.617061999999999],
    [33.3357053, -111.9920382],
    [-37.814217600000006, 144.9631608],
    [-1.2832533000000002, 36.8172449],
    [25.0750095, 55.1887608818332],
    [49.2608724, -123.11395290000002],
    [14.15550365, 121.225013458769],
    [38.3242916, -76.5168989],
    [39.7837304, -100.4458825],
    [6.1653655, -75.6001276],
    [39.7837304, -100.4458825],
    [-34.928180499999996, 138.5999312],
    [33.687438799999995, -80.4363743],
    [54.354839399999996, 18.663745499999997],
    [-33.934444, 18.869167],
    [61.0666922, -107.9917071],
    [42.6384261, 12.674297],
    [43.6211955, -84.6824346],
    [42.484154, -91.4554252],
    [32.7762719, -96.7968559],
    [45.126256500000004, -64.1022150017494],
    [39.5538771, -104.9694264],
    [40.4862174, -74.4518173],
    [40.327012700000004, -86.1746933],
    [52.131802, -106.66076699999999],
    [36.7014631, -118.75599740000001],
    [-33.928992, 18.417396],
    [63.2467777, 25.9209164],
    [39.7990175, -89.6439575],
    [51.038799700000006, -114.0274889],
    [51.8242135, 9.017351199999998],
    [52.795479099999994, -0.5402402866174321],
    [56.78611120000001, -4.1140517999999995],
    [53.38066260000001, -1.4702278],
    [32.493537800000006, 74.5411575],
    [61.0666922, -107.9917071],
    [33.71928079999999, -116.2188054],
    [53.535410999999996, -113.50799599999999],
    [51.4020055, -1.3236424999999998],
    [52.9534161, -1.1492773],
    [52.795479099999994, -0.5402402866174321],
    [52.795479099999994, -0.5402402866174321],
    [30.6253463, -96.32715379999999],
    [-37.814217600000006, 144.9631608],
    [52.795479099999994, -0.5402402866174321],
    [44.3669375, -80.7272504],
    [44.3669375, -80.7272504],
    [25.0750095, 55.1887608818332],
    [50.75, -3.75],
    [25.3336984, 51.2295295],
    [41.5051613, -81.6934446],
    [32.7174209, -117.16277140000001],
    [33.5967815, -83.86018270000001],
    [27.7567667, -81.4639835],
    [53.7919286, -2.8031167000000003],
    [44.4361414, 26.1027202],
    [41.933465600000005, -87.6739994300494],
    [41.933465600000005, -87.6739994300494],
    [47.5099289, 15.2037827],
    [38.979895299999995, -77.3489527],
    [54.702354500000006, -3.2765752999999997],
    [40.7308619, -73.9871558],
    [49.2608724, -123.11395290000002],
    [53.4791301, -2.2441009],
    [37.171626399999994, -119.77379909999999],
    [2.3923758999999998, 112.84719390000001],
    [52.413018900000004, -1.7768935000000001],
    [52.9534161, -1.1492773],
    [41.7866061698484, -73.6955756615869],
    [49.7437211, -123.08558810000001],
    [49.7437211, -123.08558810000001],
    [52.074336200000005, 4.313317],
    [9.6000359, 7.999972099999999],
    [34.0536834, -118.24276689999999],
    [54.86931020000001, 39.3932703],
    [51.262826000000004, -1.0861976],
    [51.3420841, -1.7658565],
    [-37.8493516, 145.11489803422302],
    [44.9050545, -70.80895890000001],
    [39.7012268, -74.93849909999999],
    [53.4250605, 27.6971358],
    [54.702354500000006, -3.2765752999999997],
    [39.978778600000005, -91.2110065],
    [43.1030928, -79.0302618],
    [52.50500329999999, -1.96439612333127],
    [39.672524100000004, -75.5911629],
    [52.2034823, 0.1235817],
    [61.2163129, -149.8948523],
    [55.85881005, -4.00208685912683],
    [53.340827100000006, 0.2606772],
    [41.867742799999995, -71.5814834],
    [-1.2832533000000002, 36.8172449],
    [40.4416941, -79.99008609999998],
    [41.875561600000005, -87.6244212],
    [39.1014537, -84.5124602],
    [51.5073219, -0.1276474],
    [41.47441105, -88.05876255177401],
    [52.9534161, -1.1492773],
    [39.7837304, -100.4458825],
    [53.340827100000006, 0.2606772],
    [41.47441105, -88.05876255177401],
    [54.702354500000006, -3.2765752999999997],
    [32.5556091, 35.8493023],
    [51.6663189, -3.1974329],
    [55.85665600000001, -4.2435817],
    [54.702354500000006, -3.2765752999999997],
    [37.8708393, -122.27286389999999],
    [53.4791301, -2.2441009],
    [-26.2227778, 27.89],
    [52.795479099999994, -0.5402402866174321],
    [-37.814217600000006, 144.9631608],
    [54.702354500000006, -3.2765752999999997],
    [51.4819265, -3.2327781000000004],
    [55.85665600000001, -4.2435817],
    [13.7538929, 100.8160803],
    [40.9699889, -77.72788309999999],
    [51.5097953, -0.13649070000000002],
    [-28.816623600000003, 24.991639000000003],
    [53.959055500000005, -1.0815361000000001],
    [45.5202471, -122.6741949],
    [40.7308619, -73.9871558],
    [40.6613339654474, -78.7691855876291],
    [40.7308619, -73.9871558],
    [51.7967047, 0.5793388820960109],
    [43.8222157, 17.6896937],
    [20.0171109, 103.378253],
    [51.5073219, -0.1276474],
    [50.8220399, -0.1374061],
    [25.0750095, 55.1887608818332],
    [52.865196, -7.9794599],
    [53.797418500000006, -1.5437941000000002],
    [39.7837304, -100.4458825],
    [-33.0191604, 27.899857300000004],
    [43.5972745, 1.4439371],
    [39.7837304, -100.4458825],
    [27.947759499999997, -82.458444]
  ],
  lyphoma: [],
  malaria: [
    [44.424563799999994, -121.2383729],
    [20.0171109, 103.378253],
    [5.2347220000000005, 6.7525],
    [41.6500201, -72.7342163],
    [49.2608724, -123.11395290000002],
    [34.0536834, -118.24276689999999],
    [9.064330499999999, 7.4892974],
    [9.6000359, 7.999972099999999],
    [31.20143875, -97.7717578135356],
    [39.7837304, -100.4458825],
    [-6.5247123, 35.7878438],
    [28.6141793, 77.2022662],
    [9.6000359, 7.999972099999999]
  ]
};

export default data;
